<p-card>
    <ng-container *ngIf="!isLoading && videoUrl">
        <video
            #videoPlayer
            [src]="videoUrl"
            width="100%"
            height="auto"
            (loadedmetadata)="duration = videoRef.nativeElement.duration">
        </video>
        <div class="controls">
            <div class="slider">
                <p-slider
                    [min]="0"
                    [max]="duration"
                    [step]="1"
                    [(ngModel)]="currentTime"
                    (onSlideEnd)="onSeek($event)"
                    [style]="{ width: '100%' }">
                </p-slider>
            </div>
            <div class="buttons">
                <div class="flex align-items-center">
                    <button
                        pButton icon="{{ isPlaying ? 'pi pi-pause' : 'pi pi-caret-right' }}"
                        label="{{ isPlaying ? 'Pause' : 'Play' }}"
                        (click)="togglePlayPause()"
                        class="p-button-info p-mr-2"
                    ></button>
                    <span style="color: rgba(0,0,0,0.4)" class="ml-4">{{formatTime(currentTime)}} / {{formatTime(duration)}}</span>
                </div>
                <button
                    pButton icon="{{ isMuted ? 'pi pi-volume-off' : 'pi pi-volume-up' }}"
                    label="{{ isMuted ? 'Unmute' : 'Mute' }}"
                    (click)="toggleMute()"
                    class="p-button-info p-mr-2"
                ></button>
            </div>
        </div>
    </ng-container>
</p-card>
